import { logger } from '@sentry/react';
import { BasePage } from 'components/page/BasePage';
import { useEffect } from 'react';
import { LinkButton } from 'styles/theme_styles/button';

export function NotFound() {
    useEffect(() => {
        logger.warn('NotFound', {
            path: window.location.pathname,
        });
    }, []);

    return (
        <BasePage>
            <h1>Not Found</h1>
            <p>
                The page you are looking for was not found. If you got here through a
                bookmark, you will need to update your bookmark.
            </p>
            <LinkButton href="/">Go Home</LinkButton>
        </BasePage>
    );
}
